import "katex/dist/katex.min.css";
import "./src/styles/custom.css";

export const onClientEntry = () => {
  console.log("useless.");
};
